(() => {
  const closeMenu = (button) => {
    const header = button.closest('.site-header');
    const nav = header?.querySelector('[data-mobile-nav]');
    if (!nav) return;
    nav.hidden = true;
    button.setAttribute('aria-expanded', 'false');
    button.querySelector('[data-menu-open]').hidden = false;
    button.querySelector('[data-menu-close]').hidden = true;
  };

  document.addEventListener('click', (event) => {
    const menuButton = event.target.closest('[data-menu-toggle]');
    if (menuButton) {
      const header = menuButton.closest('.site-header');
      const nav = header?.querySelector('[data-mobile-nav]');
      if (!nav) return;
      const opening = nav.hidden;
      if (opening) {
        nav.hidden = false;
        menuButton.setAttribute('aria-expanded', 'true');
        menuButton.querySelector('[data-menu-open]').hidden = true;
        menuButton.querySelector('[data-menu-close]').hidden = false;
      } else {
        closeMenu(menuButton);
      }
      return;
    }

    if (event.target.closest('.mobile-nav a')) {
      document.querySelectorAll('[data-menu-toggle]').forEach(closeMenu);
    }

    const filterButton = event.target.closest('[data-filter]');
    if (filterButton) {
      const root = filterButton.closest('[data-inspiration]');
      if (!root) return;
      const filter = filterButton.dataset.filter;
      let visible = 0;
      root.querySelectorAll('[data-filter]').forEach((button) => {
        const active = button === filterButton;
        button.classList.toggle('active', active);
        button.setAttribute('aria-pressed', String(active));
      });
      root.querySelectorAll('[data-category]').forEach((card) => {
        const show = filter === 'Alles' || card.dataset.category === filter;
        card.hidden = !show;
        if (show) visible += 1;
      });
      const status = root.querySelector('[data-filter-status]');
      if (status) status.textContent = `${visible} ${root.dataset.resultsLabel}`;
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') document.querySelectorAll('[data-menu-toggle][aria-expanded="true"]').forEach(closeMenu);
  });

  const initContact = (scope = document) => {
    scope.querySelectorAll('[data-contact-form]').forEach((form) => {
      const select = form.querySelector('[data-service-select]');
      if (!select) return;
      const requested = new URLSearchParams(window.location.search).get('dienst');
      if (requested && Array.from(select.options).some((option) => option.value === requested)) select.value = requested;
      const update = () => {
        const school = ['Onderhoud voor mijn school', 'Filamentservice'].includes(select.value);
        const schoolFields = form.querySelector('[data-school-fields]');
        const filament = form.querySelector('[data-filament-option]');
        if (schoolFields) schoolFields.hidden = !school;
        if (filament) filament.hidden = select.value !== 'Onderhoud voor mijn school';
        const message = form.querySelector('[data-message-field]');
        if (message) message.placeholder = school ? message.dataset.schoolPlaceholder : message.dataset.defaultPlaceholder;
      };
      select.addEventListener('change', update);
      update();
    });
  };

  initContact();
  document.addEventListener('shopify:section:load', (event) => initContact(event.target));
})();
